export default __webpack_public_path__ + "40eaa64efe3ecba2c58fac4792fe2caf.svg";